module.exports = __webpack_public_path__ + "static/media/img_fx.be0b46cd.png";